/* eslint-disable @next/next/no-img-element */
/* eslint-disable react/prop-types */
import styled from '@emotion/styled';
import H2 from '@base/H2/H2';
import Button from '@base/Button/Button';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import { getImage } from '@utils/imageHelper';

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(24, 32px);
  grid-column-gap: 16px;
  box-shadow: ${boxShadowGenerator()};
  border-radius: 8px;
  margin-top: 120px;
`;

const LeftWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  grid-column-start: 3;
  grid-column-end: 13;
  padding: 56px 0;
`;

const RightWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  grid-column-end: 25;
  grid-column-start: 15;
`;

const LearningButton = styled(Button)`
  width: auto;
  height: auto;
  padding: 18px 32px;
  font-size: 20px;
  margin-right: 32px;
`;

const ActionsWrap = styled.div`
  margin-top: 32px;
  display: flex;
  align-items: center;
`;

// const BlueH4 = styled(H4)`
//   font-size: 16px;
//   line-height: 150%;
//   color: var(--color-i-blue);
// `;

const ThirdSection = ({ openAccountDrawer }) => {
  const onClick = () => {
    openAccountDrawer();
  };
  // const onClickLogin = () => {
  //   openAccountDrawer('login');
  // };
  return (
    <Wrapper>
      <LeftWrapper>
        <H2>
          Learning must never stop.
          <br />
          Conduct your classes online for free.
        </H2>
        <ActionsWrap>
          <LearningButton label="Get Started" color="blue" onClick={onClick} />
          {/* <UnderlineLink color="var(--color-i-blue)" onClick={onClickLogin} href="">
            <BlueH4>I have an account</BlueH4>
          </UnderlineLink> */}
        </ActionsWrap>
      </LeftWrapper>
      <RightWrapper>
        <img
          src={getImage('/classroom/teach_side.png')}
          alt="Teach Side"
          height="489"
        />
      </RightWrapper>
    </Wrapper>
  );
};

export default ThirdSection;
